/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';

import GradeNotification from 'bundles/compound-assessments/components/form-parts/GradeNotification';
import Option from 'bundles/compound-assessments/components/form-parts/checkbox/Option';
import type { FormPartsValidationStatus } from 'bundles/compound-assessments/components/form-parts/lib/checkResponsesInvalid';
import { typeNames } from 'bundles/compound-assessments/constants';
import type {
  CheckboxPrompt,
  CheckboxReflectPrompt,
  CheckboxReflectResponse,
  CheckboxResponse,
} from 'bundles/compound-assessments/types/FormParts';

type Prompt = CheckboxPrompt | CheckboxReflectPrompt;
type Response = CheckboxResponse | CheckboxReflectResponse;

type Props = {
  prompt?: Prompt;
  response?: Response;
  onChangeResponse: (response: Response) => void;
  isDisabled: boolean;
  isReadOnly: boolean;
  role?: string;
  ariaLabelledBy?: string;
  ariaDisabled?: boolean;
};

export const checkInvalid = (): FormPartsValidationStatus | null => null;

const styles = {
  optionContainer: (theme: Theme) =>
    css({
      ':not(:first-child)': {
        marginTop: theme.spacing(12),
      },
    }),
};

class Checkbox extends React.Component<Props> {
  toggleValue = (value: string) => {
    const { onChangeResponse, response } = this.props;
    const chosen = [...((((response || {}).definition || {}).value || {}).chosen || [])];

    const chosenIndex = chosen.indexOf(value);

    if (chosenIndex === -1) {
      chosen.push(value);
    } else {
      chosen.splice(chosenIndex, 1);
    }

    onChangeResponse({
      typeName: typeNames.AUTO_GRADABLE_RESPONSE,
      definition: {
        value: {
          chosen,
        },
      },
    });
  };

  render() {
    const { prompt, response, isDisabled, isReadOnly, role, ariaLabelledBy, ariaDisabled } = this.props;

    if (prompt) {
      const chosen = (((response || {}).definition || {}).value || {}).chosen || [];
      const { options } = prompt.variant.definition;
      return (
        <div role={role ?? 'group'} aria-labelledby={ariaLabelledBy}>
          {options &&
            options.map((option) => (
              <div key={option.id} css={styles.optionContainer}>
                <Option
                  onChange={() => this.toggleValue(option.id)}
                  option={option}
                  isSelected={chosen.includes(option.id)}
                  isDisabled={isDisabled}
                  isReadOnly={isReadOnly}
                  promptId={prompt.id}
                  inputHtmlAttributes={{
                    'aria-disabled': ariaDisabled,
                  }}
                />
                <GradeNotification prompt={prompt} option={option} />
              </div>
            ))}
          <GradeNotification prompt={prompt} />
        </div>
      );
    }
    return null;
  }
}

export default Checkbox;
